import React from "react"
import { useLocation } from "@reach/router"
import { Link as GatsbyLink } from "gatsby"
import { Badge, Box, Flex, HStack, Link, Text } from "@chakra-ui/react"
import { useStaticQuery, graphql } from "gatsby"

const Navbar = () => {
  const location = useLocation()
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            youtube
          }
        }
      }
    `
  )
  const { siteMetadata } = data.site
  const links = [
    { href: "/", text: "節目" },
    { href: "/about/", text: "關於" },
    {
      href: "https://overbuild.substack.com/",
      text: "訂閱",
      external: true,
    },
    { href: siteMetadata.youtube, text: "YouTube", external: true },
  ]

  return (
    <Flex
      as="header"
      py={{ base: 5, md: 8 }}
      align={{ base: "flex-start", md: "center" }}
      justify="space-between"
      direction={{ base: "column", md: "row" }}
      sx={{ gap: "1.25rem" }}
    >
      <Link
        as={GatsbyLink}
        to="/"
        display="inline-flex"
        alignItems="center"
        _hover={{ textDecoration: "none" }}
        aria-label="頂樓加蓋 Overbuild 首頁"
      >
        <Flex
          w="44px"
          h="44px"
          flexShrink="0"
          align="center"
          justify="center"
          bg="brand.800"
          color="white"
          borderRadius="12px"
          fontWeight="800"
          letterSpacing="-0.03em"
          boxShadow="0 8px 20px rgba(12, 41, 39, 0.18)"
        >
          OB
        </Flex>
        <Box ml="3">
          <HStack spacing="2">
            <Text fontSize="lg" fontWeight="800" letterSpacing="-0.02em">
              頂樓加蓋
            </Text>
            <Badge colorScheme="green" variant="subtle" fontSize="0.6rem">
              beta
            </Badge>
          </HStack>
          <Text fontSize="xs" color="blackAlpha.600" letterSpacing="0.1em">
            OVERBUILD PODCAST
          </Text>
        </Box>
      </Link>

      <Flex as="nav" aria-label="主要導覽" wrap="wrap" mx="-1">
        {links.map(link => {
          const isCurrent =
            !link.external &&
            (link.href === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(link.href))
          const sharedProps = {
            px: { base: 2, sm: 3 },
            py: 2,
            mx: 1,
            mb: 1,
            minH: "44px",
            display: "inline-flex",
            alignItems: "center",
            borderRadius: "8px",
            fontSize: "sm",
            fontWeight: "700",
            color: isCurrent ? "brand.800" : "blackAlpha.700",
            bg: isCurrent ? "brand.50" : "transparent",
            _hover: {
              color: "brand.800",
              bg: "blackAlpha.50",
              textDecoration: "none",
            },
          }

          return link.external ? (
            <Link key={link.href} href={link.href} isExternal {...sharedProps}>
              {link.text}
            </Link>
          ) : (
            <Link
              key={link.href}
              as={GatsbyLink}
              to={link.href}
              aria-current={isCurrent ? "page" : undefined}
              {...sharedProps}
            >
              {link.text}
            </Link>
          )
        })}
      </Flex>
    </Flex>
  )
}

export default Navbar
